<template>
  <i-dropdown v-model:isOpen="open" @open="tableOpen">
      <template v-slot:trigger="{toggle, attrs}">
        <i-button ref="button" :disabled="disabled" @click.prevent="toggle" v-bind="$attrs">
          <i-icon icon="table" :title="__('Insert Table')"></i-icon>
        </i-button>
      </template>
      <template #default="{ isOpen, close, activeIndex }">
        <ul class="dropdown-menu i-dropdown-menu block">
          <UseFocusTrap v-if="isOpen" :options="{ immediate: true, allowOutsideClick: true }">
            <form>
              <!-- Input for rows -->
              <div class="form-group row-cols">
                <div>
                  <label for="rows">{{ __('Rows') }}</label>
                  <input v-model="rows" ref="rowsInput" type="number" id="rows" tabindex="0" name="rows" min="1" />
                </div>
                <div>
                  <label for="columns">{{ __('Columns') }}</label>
                  <input v-model="cols" type="number" id="columns" tabindex="0" name="columns" min="1" />
                </div>
                <i-button @click.prevent="editor.chain().focus().insertTable({ rows, cols, withHeaderRow: false }).run()">
                  <i-icon icon="table" :title="__('Insert Table')"></i-icon>
                  <span>{{ __('Insert Table') }}</span>
                </i-button>
              </div>
            </form>
          </UseFocusTrap>
        </ul>
      </template>
  </i-dropdown>
</template>

<script>
import globals from '@/globals.js'
import Button from '@/components/lib/button/Button.vue'
import Icon from '@/components/lib/icon/Icon.vue'
import Dropdown from '@/components/lib/dropdown/Dropdown.vue'
import { UseFocusTrap } from '@vueuse/integrations/useFocusTrap/component';

export default {
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
    UseFocusTrap,
  },
  data() {
    return {
      open: false,
      rows: 3,
      cols: 2,
    }
  },
  props: {
    editor: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
    },
  },
  mounted() {
    this.$refs.button && (this.button = this.$refs.button.$el || this.$refs.button)
  },
  methods: {
    __(str) {
      return globals.I.gt.__(str)
    },
    tableOpen() {
      this.$refs.rowsInput.focus();
    },
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
/* General dropdown menu style */
.i-dropdown-menu {
  display: block;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 15px;
  z-index: 1000;
}

/* Form Group */
.form-group {
  display: flex;
  justify-content: space-between;
  margin: 10px;
}

.row-cols {
  display: flex;
  gap: 10px; /* Adds spacing between the inputs */
}

.row-cols div {
  display: flex;
  flex-direction: column;
}

.row-cols label {
  font-size: 14px;
  margin-bottom: 5px;
  color: #555;
}

.row-cols input {
  width: 70px; /* Adjusted width for better usability */
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

/* Submit Button */
.submit-button {
  background-color: #007bff;
  color: #fff;
  padding: 8px 12px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.submit-button:hover {
  background-color: #0056b3;
}
</style>